import '../styles/simple-circular-progress.css';

import { translate } from '@/ui/i18n';

import { displayDecimal } from '../utils/display-scores.utils';

type SimpleCircularProgressProps = {
  percentage: number | undefined;
  visible?: boolean;
};

export function SimpleCircularProgress({
  percentage,
  visible = true,
}: SimpleCircularProgressProps) {
  const radius = 8;
  const stroke = 2;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset =
    typeof percentage === 'number'
      ? circumference - (percentage / 100) * circumference
      : circumference;

  return (
    <div
      className="simple-circular-progress-container"
      style={{ visibility: visible ? 'visible' : 'hidden' }}
    >
      <svg
        height={radius * 2}
        width={radius * 2}
        className="simple-circular-progress"
      >
        <circle
          stroke="#eee"
          fill="none"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="#2D1D1B"
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <span className="simple-circular-progress-label">
        {(typeof percentage === 'number' && (
          <>
            {displayDecimal(percentage)}
            {translate('PdfExports.completion-rate')}
          </>
        )) || <>{translate('PdfExports.unknown-completion-rate')}</>}
      </span>
    </div>
  );
}
